import { Navbar } from "@/components/Navbar";

export function Shell({ children }) {
  return <div className="min-h-screen bg-background"><Navbar /><div className="max-w-6xl mx-auto px-6 md:px-10 pt-32 pb-24">{children}</div></div>;
}
